import { render, staticRenderFns } from "./Not.vue?vue&type=template&id=4df40610&"
import script from "./Not.vue?vue&type=script&lang=ts&"
export * from "./Not.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports